<script setup lang="ts">
/**
 * PageErrorScreen — 「頁面錯誤」全屏提示（gameId 相關）。
 *
 * 對應 useGameId 的 `pageError`：缺 gameId 參數、gameUrl 沒設、
 * 該 gameId 在 sandbox/rel/prod 尚未建立 …… 等「連遊戲都指不到」的情況。
 *
 * 與 `AuthErrorScreen` 的分工：本頁是**遊戲路徑**問題（進不了這款遊戲），
 * 認證失敗請用 AuthErrorScreen。兩者在 App.vue 互斥顯示。
 *
 * 純展示元件：只吃一個 message，不自己讀 store。
 */
defineProps<{
  /** 要顯示的錯誤訊息（來源 = useGameId 的 pageError） */
  message: string
}>()
</script>

<template>
  <section class="relative z-10 grid h-full place-items-center p-6">
    <div class="w-full max-w-3xl rounded-xl border border-white/10 bg-white/5 p-5 text-white/90">
      <h1 class="m-0 mb-2 text-lg font-bold">Game Host</h1>
      <p class="m-0 break-words leading-relaxed">{{ message }}</p>
    </div>
  </section>
</template>
